import React from "react";
import "./Correctifs.scss";
import {
	Link as Aref,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
} from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import {
	CallsClient,
	FollowUpDto,
	StatusCallDto,
} from "../../../Services/elco.API.Swagger";
import InputIcon from "@material-ui/icons/Input";
import { navigationStore } from "../../../stores/NavigationStore";
import { headerStore } from "../../../stores/HeaderStore";
import { AvailableImgs } from "../../../Models/AvailableImgs";
import { footerStore } from "../../../stores/FooterStore";
import { backgroundStore } from "../../../stores/BackgroundStore";
import PageWithTablesTemplate from "../../../Components/PageWithTablesTemplate/PageWithTablesTemplate";
import DropdownFilterCell from "../../../Components/DropdownFilterCell/DropdownFilterCell";
import CorrectsReports from "./Documents/Documents";

type props = {
	contract: string;
	site: string;
};

type state = {
	contractId: string;
	siteId: string;
	callId: string;
	contractName: string;
	siteName: string;
	selectedRow: any;
	dialogOpen: boolean;
	followUps: FollowUpDto[];
	status: StatusCallDto[];
	callClient: CallsClient;
};

export default class Correctifs extends React.Component<
	RouteComponentProps<props>,
	state
> {
	constructor(props: RouteComponentProps<props>) {
		super(props);

		this.state = {
			contractId: props.match.params.contract,
			siteId: props.match.params.site,
			contractName: "",
			siteName: "",
			selectedRow: null,
			callId: "",
			dialogOpen: false,
			followUps: [],
			status: [],
			callClient: new CallsClient(),
		};

		this.state.callClient
			.getAllFollowUp()
			.then((response) => this.setState({ followUps: response || [] }));
		this.state.callClient
			.getAllStatus()
			.then((response) => this.setState({ status: response || [] }));

		navigationStore.setState({
			contractId: decodeURIComponent(this.state.contractId),
			siteId: decodeURIComponent(this.state.siteId),
			callId: null,
			title: "Rapports d'appels correctifs",
		});

		headerStore.setState({
			leftImgSrc: AvailableImgs.TwentyFourHDepanage,
			rightImgSrc: AvailableImgs.Logo,
			text: "Nous saurons vous convaincre par notre compétence",
		});

		footerStore.setState({
			show: true,
			leftText: null,
			centerText:
				"Conception et réalisation d'installations thermiques, de climatisation, de réfrigération, d'installations sanitaires et d'électricité moyenne tension",
			rightText: null,
		});

		backgroundStore.setState({
			img: AvailableImgs.FondCollecteur2,
		});
	}

	getFollowUpText(dataItem: any) {
		const item = this.state.followUps.find(
			(f) => f.followup === dataItem.followUp
		);
		if (item) {
			return item.description;
		}
	}

	render() {
		return (
			<React.Fragment>
				<PageWithTablesTemplate
					className="corrects"
					buttonCenter={{
						isEnableWhenRowSelected: false,
						label: "Retour",
						url: "/contracts/" + this.state.contractId + "/sites",
					}}
					buttonBottom={{
						isEnableWhenRowSelected: false,
						label: "Accueil",
						url: "/",
					}}
					tables={[
						{
							tableId: `correctTable__${this.state.contractId}_${this.state.siteId}`,
							enableFilters: true,
							promiseData: (options) =>
								this.state.callClient.getCorrectionCall(
									this.state.contractId,
									this.state.siteId,
									options
								),
							colunsDefinition: [
								{
									title: "Création",
									field: "actionDateTime",
									renderingComponent: (props) => (
										<td>
											{new Date(
												props.dataItem.actionDateTime
											).toLocaleDateString(navigator.language, {
												year: "numeric",
												month: "2-digit",
												day: "2-digit",
											})}
										</td>
									),
								},
								{ title: "N° d’appel", field: "callId" },
								{ title: "Sujet", field: "callSubject" },
								{ title: "V/Réf", field: "workOrder" },
								{ title: "Inst. tech.", field: "objectId" },
								{
									title: "Statut",
									field: "status",
									filterComponent: (props) => (
										<DropdownFilterCell
											items={this.state.status}
											textField="id"
											dataItemKey="id"
											placeholder="(Aucun)"
											{...props}
										/>
									),
									filterable: true,
								},
								{
									title: "Suite à donner",
									field: "followUp",
									filterComponent: (props) => (
										<DropdownFilterCell
											items={this.state.followUps}
											textField="description"
											dataItemKey="followup"
											placeholder="(Aucune)"
											{...props}
										/>
									),
									filterable: true,
									renderingComponent: (props) => (
										<td>{this.getFollowUpText(props.dataItem)}</td>
									),
								},
								{ title: "Motif de suite", field: "followUpReason" },
								{
									title: "Rapports",
									orderable: false,
									field: "hasDocuments",
									renderingComponent: (props) => (
										<td>
											{props.dataItem.hasDocuments && (
												<Aref
													href="#"
													onClick={this.handleOpenDialog(
														encodeURIComponent(props.dataItem.callId)
													)}
												>
													<InputIcon />
												</Aref>
											)}
										</td>
									),
								},
							],
							onSelectedItemChange: (item) => {
								this.setState({ selectedRow: item });
							},
							dataKey: "objectId",
						},
					]}
				/>
				<Dialog
					onClose={this.handleCloseDialog.bind(this)}
					aria-labelledby="customized-dialog-title"
					open={this.state.dialogOpen}
					fullWidth={true}
					maxWidth={"md"}
				>
					<DialogTitle id="customized-dialog-title">
						Liste des documents correctifs
					</DialogTitle>
					<DialogContent dividers>
						<CorrectsReports
							contract={this.state.contractId}
							site={this.state.siteId}
							call={this.state.callId}
						/>
					</DialogContent>
					<DialogActions>
						<Button
							autoFocus
							onClick={this.handleCloseDialog.bind(this)}
							color="primary"
						>
							Fermer
						</Button>
					</DialogActions>
				</Dialog>
			</React.Fragment>
		);
	}

	private handleOpenDialog = (itemId: string): any => {
		return () => {
			this.setState({
				callId: itemId,
				dialogOpen: true,
			});
		};
	};
	private handleCloseDialog = () => {
		this.setState({
			dialogOpen: false,
		});
	};
}
